<template>
<b-row class="no-gutters m-2">
    <b-col>
        <b-form @submit="onSubmit" id="form-general-settings">
            <b-row class="OTsectionHeader">
                <b-col cols="12" md="6">
                    <h1>Job Information</h1>
                </b-col>
                <b-col class="text-right OTbtnContainer" cols="12" md="6">
                    <b-button type="button" variant=" OTSecondary" @click="$router.push({ name: 'jobs'})">Cancel</b-button>
                    <b-button type="submit" variant=" OTPrimary" :disabled="$v.$invalid">Save</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <otif-textInput
                        id="job_name"
                        label="Job Name"
                        v-model="job_name" name="name" :validation="$v.job_name" invalidMessage="Job name is required" class="w-50"/>
                    <project-select id="project_id" label="Project" v-model="project_id" :validation="$v.project_id" invalidMessage="You must pick a project"  class="w-50"/>
                    <otif-textarea id="description" label="Description" v-model="job_description"  class="w-50"/>
                </b-col>
            </b-row>
            
                <b-row>
                    <b-col>
                        <template v-if="tme_profiles_loading">
                            Loading TME Profiles ...
                        </template>
                        <template v-else>
                            <otif-select
                                class="w-50"
                                label="TME Profile Selection"
                                description="Choose between automatically selecting a profile based on the content, or manually choose one to be applied to all content"
                                v-model="auto_profile_id"
                                :values="[{
                                    value: 'true',
                                    label: 'Automatic - A TME profile will be chosen based on the content being processed'
                                },{
                                    value: 'false',
                                    label: 'Manual - Choose a TME profile from the list below'
                                }]"/>

                            <otif-select
                                class="w-50"
                                label="Choose Text Mining Profile"
                                description="Select below the annotation profile to use for this job. This profile is defining which semantic annotations will be retrieved and made available."
                                id="text-mining-profile"
                                v-model="profile_id"
                                name="text-mining-profile"
                                :values="profiles"
                                v-if="auto_profile_id === 'false'"
                                :disabled="tme_profile_error === true || tme_profiles_loading === true"/>
                        </template>

                    </b-col>
                </b-row>
                <b-row v-if="tme_profiles_loading === false && tme_profile_error === false && profiles.length === 0">
                    <b-col>
                        <b-alert variant="warning" show>
                            No profiles are currently available. Click <a href="#/settings/annotation-profiles">here</a> to create and manage your TME profiles.
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row v-else-if="tme_profiles_loading === false && tme_profile_error === true">
                    <b-col>
                        <b-alert class="OTAlert OTAlertError" show>
                            <span class="ot-icon-alert-title"></span>
                            Magellan Text Mining Engine is unavailable.</b-alert>
                    </b-col>
                </b-row>
            <template v-if='job_type=="ECM" && ecm_annotation_change==true'>
                <b-row>
                    <b-col cols="12">
                        <b-alert class="OTAlert OTAlertInformation" show>
                        <span class="ot-icon-alert-title"></span>
                            You might need to update annotation options on the "Annotation" tab.
                        </b-alert>
                    </b-col>
                </b-row>
            </template>
            <otif-table
                title="Custom Property List"
                :columns="columns"
                :rows="properties"
                :paginated="false"
                @change="onPropertiesChange"/>
        </b-form>
    </b-col>
</b-row>

</template>

<script>
import ProjectSelect from '@/components/widgets/ProjectSelector.vue';
import FormActions from '@/components/jobEditing/FormActions.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { resourceMapper } from '@/utils/resourceMapper.js';
import { mkdir } from 'fs';
import axios from 'axios';

export default {

    mixins: [ validationMixin ],

    components: {
        'project-select': ProjectSelect,
        FormActions
    },

    props: {
        job_id: {
            required: false
        },
        job: {
            required: false
        }

    },

    data() {
        return {
            form: {
                job_name: '',
                project_id: '',
                job_description: ''
            },
            tme_profile_error: false,
            tme_profiles_loading: true,
            auto_profile_id: 'true',
            ecm_annotation_change:false,
            propertiesArray: [],
            columns: [{
                name: 'prop_name',
                label: 'Property Name'
            },{
                name: 'prop_value',
                label: 'Property Value'
            }],
            profiles: []
        }
    },

    validations: {
        job_name: {
            required
        },
        project_id: {
            required
        }
    },

    computed: {
        properties: {
            cache: false,
            get() {
                const props = this.$lodash.get(this.job.attributes, 'job_criteria.pipeline_custom_properties', {});
                return Object.keys(props).map((k) => {
                    return [k, props[k]];
                });
            },
            set() {
            }
        },

        ...resourceMapper(['job_name', 'job_description', 'job_type', 'project_id', 'profile_id'], 'job', 'general-settings'),
    },

    watch: {
        auto_profile_id(newVal) {
            console.log('auto profile id:', newVal);
            if (newVal === 'true') {
                this.profile_id = '';
            } else {
                if (this.profile_id === '' || this.profile_id==undefined) {
                    this.profile_id = this.profiles[0].value;
                }
            }
            if(this.job_type=="ECM" && this.tme_profiles_loading == false)
            {
                this.ecm_annotation_change=true;
            }
        },
        profile_id(newVal) {
            console.log('profile id changed:', newVal);
            if (newVal !== '') {
                this.auto_profile_id = 'false';
            }
            if(this.job_type=="ECM" && this.tme_profiles_loading == false)
            {
                this.ecm_annotation_change=true;
            }
        }
    },

    methods: {
        toggleNoProfileId() {
            if (this.profile_id) {
                this.profile_id = '';
            }
        },

        onPropertiesChange($e) {

            var props = $e.rows.reduce((accumulator, currentValue) => {
                accumulator[currentValue[0]] = currentValue[1];
                return accumulator;
            }, {});

            this.job.set('job_criteria.pipeline_custom_properties', props);
            this.$eventBus.$emit('section-changed', 'general-settings');
        },

        onReset($e) {
            // noop
        },

        onSubmit($e) {
            $e.preventDefault();
            this.job.save();
        },

        async refresh_profiles() {
            this.tme_profiles_loading = true;
            try {
                const res = await axios.get('/mtm-gateway-api/v1/services/pipeline/otca-profiles');
                this.tme_profile_error = false;

                this.profiles = res.data.otcaProfiles.map((profile) => {
                    return {
                        value: profile.profileId,
                        label: profile.name
                    }
                }).sort((a, b) => {
                    if (a.label > b.label) {
                        return 1;
                    } else if (a.label < b.label) {
                        return -1;
                    } else {
                        return 0;
                    }
                });

            } catch (e) {
                console.error(e);
                this.tme_profile_error = true;
            }

            this.tme_profiles_loading = false;
        }
    },

    mounted() {
        this.refresh_profiles();

        if (this.job.attributes.profile_id) {
            this.auto_profile_id = 'false';
        }
        this.ecm_annotation_change=false;
        var breadcrumbs = [{
            name: 'jobs',
            meta: { label: 'Jobs' }
        },{
            name: 'job-edit',
            params: {
                job_id: this.job.id
            },
            meta: { label: this.job.get('job_name') }
        },{
            name: 'general-settings',
            params: {
                job_id: this.job_id
            },
            meta: { label: 'General Settings' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    }
}

</script>
